/*
 * @Author: Dong
 * @Date: 2022-04-06 13:56:03
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-04-04 18:30:00
 */
import { SERVER_STATUS, SYS_STATUS, UPDATE_ENV, UPDATES_DIR } from './constant';
import * as fileConfig from './fileConfig/actions';
import * as syncBack from './syncBack/actions';
import * as installList from './Install/actions';

const serverStatus = (payload: {
  serverStatus?: string;
  sereverInfo?: any;
  partionInfo?: any;
  createSuccess?: boolean;
  status?: any;
  noSupos?: boolean;
}) => ({
  type: SERVER_STATUS,
  payload,
});

const sysStatus = (payload: { sysStatus: string }) => ({
  type: SYS_STATUS,
  payload,
});

const updateEnv = (payload: { hasEnv: boolean }) => ({
  type: UPDATE_ENV,
  payload,
});

const updateSuposDir = (payload: { hasSuposCatalogue: boolean }) => ({
  type: UPDATES_DIR,
  payload,
});

const common = {
  serverStatus,
  sysStatus,
  updateEnv,
  updateSuposDir,
};

export { common, fileConfig, syncBack, installList };
